<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script >
import wx from 'weixin-js-sdk'
export default {
  name:'app',
  mounted(){

    fetch("https://hsapp.fotile.com/user-center/api/open/wx/officialAccounts/querySign?type=1")
      .then(res => res.json())
      .then(res => {
          wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: res.appId, // 必填，公众号的唯一标识
              timestamp: res.timestamp, // 必填，生成签名的时间戳
              nonceStr: res.nonceStr, // 必填，生成签名的随机串
              signature: res.signature,// 必填，签名
              jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone', 'getLocation']
              // jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'getLocation']// 必填，需要使用的JS接口列表
          });
          wx.ready(function () {
              wx.onMenuShareTimeline({
                  title: '【掌上量尺宝-厨房重装没烦恼】', // 分享标题
                  desc: '厨房云设计服务上线，5步自测安装环境，省时省力又省心', // 分享描述
                  link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                  imgUrl: 'https://hsimage.fotile.com/001a3375-99b9-4efe-a2a5-ea517219f6b1.png', // 分享图标
                  success: function () {
                  }
              })
              wx.onMenuShareAppMessage({
                  title: '【掌上量尺宝-厨房重装没烦恼】', // 分享标题
                  desc: '厨房云设计服务上线，5步自测安装环境，省时省力又省心', // 分享描述
                  link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                  imgUrl: 'https://hsimage.fotile.com/001a3375-99b9-4efe-a2a5-ea517219f6b1.png', // 分享图标
                  success: function () {
                  }
              })
          });
      })
      .catch(e => console.error(e))
        
    }
}
</script>

<style>
#app {
  /* font-family: PingFang-SC-Bold; */
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}


</style>

